import React from 'react'

import InfoHero from '../components/Info/Hero'
import { sections } from '../constants/programmes'

const Hero = () => (
  <InfoHero
    sectionId={sections.description}
    title="O' Levels Computing"
    subtitle="Our experience in the various school curriculums"
  />
)

export default Hero
